module.exports = __webpack_public_path__ + "media/images/my_apps/physiology animations_app icon_rounded_115-b9884db3a2bbb129b8ce56f0ccecd171.png";